const config = {
     development: {
          apiUrl: 'http://localhost:3000',
          googleClientId: '10732367706-nqd025a2rfdq6elsf8po7o2mojst0fo0.apps.googleusercontent.com',
          etherscanUrl: 'https://sepolia.etherscan.io',
          XAP_CONTRACT: "0xE3FAD904f18CCb463a426d02c3dF73B72f158372",
          networkName: "sepolia",
     },
     production: {
          apiUrl: 'https://exadrive-phoenix-server.exaprotocol.com',
          googleClientId: '10732367706-nqd025a2rfdq6elsf8po7o2mojst0fo0.apps.googleusercontent.com',
          etherscanUrl: 'https://etherscan.io',
          XAP_CONTRACT: "0x66aA0E04864F2dE0Ee44d9e508e68415C04E2F57",
          networkName: "mainnet",
     }
};

const env = process.env.NODE_ENV;
console.log(env);
export default config[env]; 